import { useEffect } from 'react';
import { useQuery, registerQuery } from 'data-fetching-client';
import getIn from 'immutable-less/transmute/getIn';
import { createRpcClientV2 } from 'rpc-client-utils';
import authHttpClient from 'hub-http/clients/apiClient';
import { getDelayActionEnrollmentCountsRpc } from 'automation-ui-canvas/__generated__/chirp/com/hubspot/automationplatform/chirp/rpc/DelayedActionsService';
import { jsx as _jsx } from "react/jsx-runtime";
const POLLING_FREQUENCY_MS = 5000;
const chirpClient = createRpcClientV2({
  hubHttpClient: authHttpClient
});
export const GET_OBJECTS_IN_ACTIONS_COUNTS = registerQuery({
  fieldName: 'objectsInActions',
  args: ['flowId'],
  fetcher({
    flowId
  }) {
    return chirpClient.call(getDelayActionEnrollmentCountsRpc, {
      request: {
        flowId
      }
    }).then(res => res.items);
  }
});
export const queryObjectsInActionsPolling = WrappedComponent => props => {
  const {
    data,
    startPolling,
    stopPolling
  } = useQuery(GET_OBJECTS_IN_ACTIONS_COUNTS, {
    variables: {
      flowId: props.flowId
    }
  });
  const flowIsEnabled = getIn(['flow', 'isEnabled'], props);
  const objectsInActions = data ? data.objectsInActions : [];
  const hasObjectsInActions = objectsInActions.length > 0;
  useEffect(() => {
    const handleVisibilityChange = () => {
      if ((flowIsEnabled || hasObjectsInActions) && document.visibilityState !== 'hidden') {
        startPolling(POLLING_FREQUENCY_MS);
      } else {
        stopPolling();
      }
    };
    handleVisibilityChange();
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [hasObjectsInActions, flowIsEnabled, startPolling, stopPolling]);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    objectsInActions: objectsInActions
  }));
};
export const queryObjectsInActions = (WrappedComponent, flowId) => props => {
  const {
    data,
    loading
  } = useQuery(GET_OBJECTS_IN_ACTIONS_COUNTS, {
    variables: {
      flowId
    }
  });
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    objectsInActions: loading || !data ? [] : data.objectsInActions
  }));
};
export const queryObjectsInSingleAction = (WrappedComponent, flowId, actionId) => props => {
  const {
    data,
    loading
  } = useQuery(GET_OBJECTS_IN_ACTIONS_COUNTS, {
    variables: {
      flowId
    }
  });
  const objectsInActions = data ? data.objectsInActions : [];
  const actionWithDelayedObjects = objectsInActions.find(action => action.actionId === actionId);
  const objectCount = actionWithDelayedObjects ? actionWithDelayedObjects.count : 0;
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    objectsInActionCount: loading ? 0 : objectCount
  }));
};
export const queryTotalObjectsInActions = WrappedComponent => props => {
  const {
    flowId
  } = props;
  const {
    data
  } = useQuery(GET_OBJECTS_IN_ACTIONS_COUNTS, {
    variables: {
      flowId
    }
  });
  const objectsInActions = data ? data.objectsInActions : [];
  const objectsInActionCount = objectsInActions.reduce((total, currentAction) => total + currentAction.count, 0);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    totalObjectsInActionsCount: objectsInActionCount
  }));
};